import { createFileRoute } from "@tanstack/react-router";
import { AdminSupportWorkbenchPage } from "@/components/admin/pages/AdminSupportWorkbenchPage";
import { parseSupportWorkbenchSearch } from "@/lib/supportWorkbenchSearch";

export type { SupportWorkbenchSearch } from "@/lib/supportWorkbenchSearch";

export const Route = createFileRoute("/pulse-ops-x7k2/support/")({
  validateSearch: parseSupportWorkbenchSearch,
  component: AdminSupportWorkbenchPage,
});
